/**
 * Preview shortcuts are compiled into local development and the dedicated E2E
 * artifact only. Normal production builds never trust URL role parameters or
 * unauthenticated demo identities.
 */
export const isTrustedPreviewRuntime =
  import.meta.env.DEV || import.meta.env.VITE_E2E_MODE === 'true';
